import * as Constants from "./constants";

const API_Routes = {
    login: Constants.loginUrl,
    logout: Constants.logoutUrl,
    getCSRF: Constants.getCSRFUrl,
    loginInfo: Constants.getLoginInfoUrl,
    multiSession: Constants.handleSessionUrl,
    setLanguage: Constants.setLanguageUrl,
    changeRole: Constants.changeRoleUrl,
    getCaptchaWOTimeUrl: Constants.getCaptchaWOTimeUrl,
    viewFeedbackCSTUrl: Constants.viewFeedbackCSTUrl,
    viewFeedbackSPOCUrl: Constants.viewFeedbackINTERNALUrl,
    viewFeedbackCUSTOMERUrl: Constants.viewFeedbackCUSTOMERUrl,
    // searchFeedbackByUserUrl: Constants.setSearchUserList,
    getFeedbackTypeList: Constants.getFeedbackTypeList,
    getDepartmentAtributeMap: Constants.getDepartmentAtributeMap,
    getFeedbackSourceList: Constants.getFeedbackSourceList,
    getCustomerOldFeedbackList: Constants.getCustomerOldFeedbackList,
    getCustomerDepartmentAttributeMap: Constants.getCustomerDepartmentAttributeMap,
    uploadFeedbackAttachmentSpoc: Constants.uploadFeedbackAttachmentSpoc,
    closeFeedbackSPOCUrl: Constants.closeFeedbackSPOCUrl,
    closeFeedbackCSTURL: Constants.closeFeedbackCSTURL,
    getSpocOldFeedbackList: Constants.getOldFeedbackSPOCUrl,
    customerSatisfactionCustomerURL: Constants.customerSatisfactionCustomerURL,
    acceptFeedbackSPOCURL: Constants.acceptFeedbackSPOCURL,
    getFeedbackDetailsforFeedbackCloseURL: Constants.getFeedbackDetailsforFeedbackCloseURL,
    calculateSLAtimeURL: Constants.calculateSLAtimeURL,
    acceptFeedbackAfterOnClickURL: Constants.acceptFeedbackAfterOnClickURL,
    getUserListfromGroupName: Constants.getUserListfromGroupName,
    closeFeedbackSPOC: Constants.closeFeedbackSPOC,
    quickLogIssueSPOCURL:Constants.quickLogIssueSPOCURL,
    searchCustomerDetailsSPOCURL:Constants.searchCustomerDetailsEndPoint,
    getClientsSPOCURL:Constants.getClientsSPOCURL,
    quickIssueSubarrySPOCURL:Constants.quickIssueSubarrySPOCURL,
    quickIssueSubmitUrl:Constants.quickIssueSubmitUrl,
    getAreaByFeedbackType: Constants.getAreaByFeedbackTypeURL,
    getDepartmentAtributeMapSPOC: Constants.getDepartmentAtributeMapSPOC,
    getDetailsforReceiptSPOCURL: Constants.getDetailsforReceiptSPOCURL,
    saveFeedbackDetailsSPOC: Constants.saveFeedbackDetailsSPOC,
    // spocTagOldFeedbackReceipt: Constants.spocTagOldFeedbackReceipt,
}

export default API_Routes;
